import api from "api";

const eventFeatures = {
    getCatalog: () => {
        return api().get('/features');
    },
    get: (slug) => {
        return api().get(`/events/detail/${slug}/features`);
    },
    update: (slug, payload) => {
        return api().put(`/events/detail/${slug}/features`, payload);
    },
};

export default eventFeatures;
